<script></script>

<footer>
  <p>NevNotes</p>
  <p><a href="mailto:hege@example.com">nev@notes.com</a></p>
</footer>

<style></style>
